import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_teaching_plan_template_tab = _resolveComponent("teaching-plan-template-tab")!
  const _component_teaching_plan_transfer_rule_tab = _resolveComponent("teaching-plan-transfer-rule-tab")!
  const _component_teaching_plan_approver_tab = _resolveComponent("teaching-plan-approver-tab")!
  const _component_teaching_plan_phrase_tab = _resolveComponent("teaching-plan-phrase-tab")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_btn, {
        variant: "text",
        size: "small",
        onClick: _ctx.backToList
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("mdi-chevron-left", -1)
            ]))]),
            _: 1
          }),
          _cache[2] || (_cache[2] = _createTextVNode(" 指導計画へ戻る ", -1))
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "mt-1" }, [
      _createElementVNode("h2", null, "指導計画の帳票設定"),
      _createElementVNode("div", { class: "text-caption text-grey-darken-1 mt-1" }, " 帳票レイアウト・転記ルール・承認者・文例を管理します。管理者と施設長のみ利用できます。 ")
    ], -1)),
    (!_ctx.canManage)
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 0,
          type: "warning",
          variant: "tonal",
          class: "mt-4"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode(" この画面を利用する権限がありません。 ", -1)
          ]))]),
          _: 1
        }))
      : (_ctx.nurseryId)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_v_tabs, {
              "model-value": _ctx.tab,
              color: "primary",
              class: "mt-4",
              "onUpdate:modelValue": _ctx.onTabChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, { value: "template" }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode("レイアウト", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_tab, { value: "transferRule" }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("転記ルール", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_tab, { value: "approver" }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("承認者・提出期限", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_tab, { value: "phrase" }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("文例", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model-value", "onUpdate:modelValue"]),
            _createVNode(_component_v_divider),
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createVNode(_component_teaching_plan_template_tab, {
                ref: "templateTab",
                "nursery-id": _ctx.nurseryId,
                onTemplatesUpdated: _cache[0] || (_cache[0] = ($event: any) => (_ctx.templates = $event)),
                onOpenTransferRule: _ctx.openTransferRule,
                onOpenPhrase: _ctx.openPhrase
              }, null, 8, ["nursery-id", "onOpenTransferRule", "onOpenPhrase"]), [
                [_vShow, _ctx.tab === 'template']
              ]),
              (_ctx.tab === 'transferRule')
                ? (_openBlock(), _createBlock(_component_teaching_plan_transfer_rule_tab, {
                    ref: "transferRuleTab",
                    key: `transfer-${_ctx.transferRuleTemplateId || 'default'}`,
                    "nursery-id": _ctx.nurseryId,
                    templates: _ctx.templates,
                    "initial-target-template-id": _ctx.transferRuleTemplateId,
                    onOpenTemplate: _ctx.openTemplateEditor
                  }, null, 8, ["nursery-id", "templates", "initial-target-template-id", "onOpenTemplate"]))
                : _createCommentVNode("", true),
              (_ctx.tab === 'approver')
                ? (_openBlock(), _createBlock(_component_teaching_plan_approver_tab, {
                    key: 1,
                    ref: "approverTab",
                    "nursery-id": _ctx.nurseryId
                  }, null, 8, ["nursery-id"]))
                : _createCommentVNode("", true),
              (_ctx.tab === 'phrase')
                ? (_openBlock(), _createBlock(_component_teaching_plan_phrase_tab, {
                    key: `phrase-${_ctx.phraseTarget ? _ctx.phraseTarget.templateId : 'default'}`,
                    "nursery-id": _ctx.nurseryId,
                    templates: _ctx.templates,
                    "initial-template-id": _ctx.phraseTarget ? _ctx.phraseTarget.templateId : null,
                    "initial-phrase-key": _ctx.phraseTarget ? _ctx.phraseTarget.phraseKey : null
                  }, null, 8, ["nursery-id", "templates", "initial-template-id", "initial-phrase-key"]))
                : _createCommentVNode("", true)
            ])
          ], 64))
        : _createCommentVNode("", true)
  ]))
}